import useKeyboardShortcut, {
	isInteractiveTarget,
	isTypingTarget,
} from '@hooks/useKeyboardShortcut.hook';
import { handleEscape } from '@utils/map/object.draw';

/**
 * The keys of the object session on the map: Esc steps back one level (the
 * sketch being drawn, then the selected box, then the Exit confirm) and
 * Delete / Backspace remove the selected box. Both leave a key that was meant
 * for a field or a control to that element.
 *
 * @param {object} options
 * @param {boolean} options.enabled - an object session is running
 * @param {boolean} options.escapeEnabled - Esc may act (no dialog is open)
 * @param {boolean} options.canRemove - a box is selected, and no dialog open
 * @param {() => void} options.onExit - opens the Exit confirm
 * @param {() => void} options.onRemove - removes the selected box
 */
export const useObjectSessionKeys = ({ enabled, escapeEnabled, canRemove, onExit, onRemove }) => {
	useKeyboardShortcut('Escape', enabled && escapeEnabled, () => {
		// Esc in a field belongs to the field.
		if (isTypingTarget(document.activeElement)) return;
		if (handleEscape()) return;
		onExit();
	});

	const remove = () => {
		if (!isInteractiveTarget(document.activeElement)) onRemove();
	};
	useKeyboardShortcut('Delete', enabled && canRemove, remove);
	useKeyboardShortcut('Backspace', enabled && canRemove, remove);
};
